<script setup>
import { storeToRefs } from 'pinia';
import { useBreakpoints, breakpointsBootstrapV5 } from '@vueuse/core';
import { useAuthStore } from '../../../auth/stores/auth-store';

/**
 * Auth store
 */
const { authUser } = storeToRefs(useAuthStore());

/**
 * Bootstrap break points to change nav class
 */
const breakpoints = useBreakpoints(breakpointsBootstrapV5);

const smallerThanLg = breakpoints.smaller('lg'); // only smaller than lg
</script>

<template>
  <nav
    class="nav flex-lg-column flex-row flex-nowrap overflow-x-auto"
    :class="smallerThanLg ? 'nav-underline' : 'nav-pills'"
  >
    <RouterLink
      :to="{ name: 'account' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Account
    </RouterLink>
    <RouterLink
      v-if="authUser?.uid"
      :to="{
        name: 'profile.detail',
        params: { userId: authUser.uid },
      }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      My Profile
    </RouterLink>
    <RouterLink
      :to="{ name: 'account.change-password' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Change Password
    </RouterLink>
    <RouterLink
      :to="{ name: 'account.organizer' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Request Access
    </RouterLink>
    <RouterLink
      :to="{ name: 'account.event.organized.list' }"
      class="text-nowrap text-center text-lg-start nav-link"
    >
      Organized Events
    </RouterLink>
  </nav>
</template>
